"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.email.placeholder': 'Ingresa dirección de correo',
};
